var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as API from './api';
let ProblemManage = class ProblemManage extends Vue {
    constructor() {
        super(...arguments);
        this.items = null;
        this.add_problem_id = '';
        this.add_problem_git = '';
    }
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            let items = yield API.listProblem();
            if (items !== 'Error') {
                this.items = items;
            }
        });
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchData();
        });
    }
    onAddProblem() {
        return __awaiter(this, void 0, void 0, function* () {
            if ((yield API.updateProblem(parseInt(this.add_problem_id), this.add_problem_git)) === 'Success') {
                yield this.fetchData();
                alert('Add Problem Success!');
            }
            else {
                alert('Add Problem Failed!');
            }
        });
    }
    onRejudgeProblem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Rejudge Problem?')) {
                yield API.rejudgeProblem(item.problem.uid);
                alert('Rejudge Success!');
            }
        });
    }
    onUpdateProblem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Update Problem?')) {
                if ((yield API.updateProblem(item.problem.uid, item.git)) === 'Success') {
                    yield this.fetchData();
                    alert('Update Success!');
                }
                else {
                    alert('Update Failed!');
                }
            }
        });
    }
    onRemoveProblem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm('Remove Problem?')) {
                if (this.items !== null) {
                    if ((yield API.removeProblem(item.problem.uid)) === 'Success') {
                        let index = this.items.indexOf(item);
                        this.items.splice(index, 1);
                        alert('Remove Success!');
                    }
                    else {
                        alert('Remove Failed!');
                    }
                }
                else {
                    alert('Problem Does Not Exist!');
                }
            }
        });
    }
};
ProblemManage = __decorate([
    Component
], ProblemManage);
export default ProblemManage;



// WEBPACK FOOTER //
// ./src/ProblemManage.vue